<app-container class="auth-container" [noPadding]="handsetService.isXs" fxLayoutAlign="center" maxWidth="516px"
               ngClass.xs="xs">
  <mat-card class="card" fxLayout="column" ngClass.xs="xs">
    <mat-card-header class="header-with-big-space" fxLayout="column" fxLayoutAlign="center center">
      <a class="logo" href="https://payka.pl/">
        <img alt="payka.pl" src="/assets/images/logo-payka/logo_payka.svg" />
      </a>

      <ng-container *ngIf="!changed; else title">
        <h1>
          Ustaw nowe hasło
        </h1>
      </ng-container>
      <ng-template #title>
        <div class="flex" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="25px">
          <img alt="elipsa" src="/assets/images/icons/ellipse_done.svg" [width]="45" />
          <h1>
            Hasło zostało zmienione
          </h1>
        </div>
      </ng-template>
      <p>
        <ng-container *ngIf="!changed; else subtitle">
          Wprowadź swoje nowe hasło do Panelu Payka.
        </ng-container>
        <ng-template #subtitle>
          Hasło zostało poprawnie zmienione. Możesz teraz przejść do strony logowania.
        </ng-template>
      </p>
    </mat-card-header>
    <form [formGroup]="changePasswordForm">
      <mat-card-content
        [ngStyle]="{'min-height': changed ? '362px' : '450px'}">
        <div ngClass.xs="xs" fxFlex.xs class="container-content">
          <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">

            <div *ngIf="!changed" fxLayout="column" fxLayoutGap="12px">

              <mat-form-field appearance="outline" class="text-grey password-form-field" [hideRequiredMarker]="true">
                <mat-label>Nowe hasło</mat-label>
                <input
                  matInput
                  type="password"
                  [formControl]="changePasswordForm.newPassword"
                  name="newPassword"
                  autocomplete="new-password"
                  tabindex="0"
                  appGtmFormEvent
                  [type]="passwordVisible ? 'text' : 'password'"
                  [eventField]="'newPassword'"
                  [eventForm]="formName" />

                <button
                  matSuffix
                  mat-icon-button
                  type="button"
                  class="password-visibility-btn"
                  [matTooltip]="passwordVisible ? 'Ukryj hasło' : 'Pokaż hasło'"
                  (click)="passwordVisible = !passwordVisible">
                  <app-icon
                    [name]="passwordVisible ? 'visibility_off_filled' : 'visibility_filled'"
                    color="rgba(0,0,0,.5)"
                    size="20"
                    matSuffix
                  ></app-icon>
                </button>
              </mat-form-field>

              <div class="password-help">
                <app-password-meter
                  [password]="changePasswordForm.newPassword.value"
                  [color]="billtechPayMode ? 'green' : 'primary'"
                ></app-password-meter>
              </div>

              <mat-error *ngFor="let error of errors" class="error-message status-error">
                {{ errorMessages[error] }}
              </mat-error>


            </div>

            <div class="actions-login" fxLayout="column" fxLayoutAlign="start center">
              <app-new-loader-button
                *ngIf="!changed"
                [disabled]="submitted && !changePasswordForm.valid"
                [loading]="loading"
                (buttonClick)="onChangePassword()"
                class="auth-button"
                id="login-button"
                [customType]="LoaderButtonType.RAISED"
                color="accent">
                Dalej
              </app-new-loader-button>
              <app-new-loader-button
                *ngIf="changed"
                [routerLink]="loginUrl"
                [queryParams]="getQueryParams()"
                [loading]="loading"
                class="auth-button"
                [customType]="LoaderButtonType.RAISED"
                color="accent">
                Przejdź do logowania
              </app-new-loader-button>
            </div>

          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="column" class="flex" style="align-self: center;">
      </mat-card-actions>
      <mat-card-footer>
        <div class="lock" fxLayout="column" fxLayoutAlign="center center">
          <img alt="lock" src="/assets/images/icons/lock.svg" />
        </div>
      </mat-card-footer>
    </form>
  </mat-card>
</app-container>
